import { render, staticRenderFns } from "./TsPreviewPdf.vue?vue&type=template&id=4b4af403&scoped=true&"
import script from "./TsPreviewPdf.vue?vue&type=script&lang=js&"
export * from "./TsPreviewPdf.vue?vue&type=script&lang=js&"
import style0 from "./TsPreviewPdf.vue?vue&type=style&index=0&id=4b4af403&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4af403",
  null
  
)

export default component.exports